import { Box } from '@mui/material';
import tokens from '../shared/theme/tokens';

/**
 * Status pill driven by the central tokens.statusColors map — one source of
 * truth for lease, application, KYC, work-order, and verification statuses.
 * Unknown statuses fall back to the neutral pair.
 *
 * Props:
 * - status: string used for the color lookup (case-insensitive)
 * - label: display text (defaults to status)
 * - tone: optional explicit tone key ('success' | 'warning' | ...) that
 *   overrides the status lookup
 * - dot: show the leading status dot (default true)
 * - size: 'medium' | 'small'
 */
export default function StatusChip({ status, label, tone, dot = true, size = 'medium', sx }) {
  const key = (tone || status || '').toLowerCase();
  const colors = tokens.statusColors[key] || tokens.statusColors.neutral;
  const small = size === 'small';

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.6,
        borderRadius: `${tokens.radius.pill}px`,
        px: small ? 1 : 1.25,
        py: small ? '1px' : '3px',
        fontSize: small ? 10.5 : 12,
        fontWeight: 600,
        lineHeight: 1.5,
        backgroundColor: colors.bg,
        color: colors.fg,
        whiteSpace: 'nowrap',
        ...sx,
      }}
    >
      {dot && <Box component="span" sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: 'currentColor', flexShrink: 0 }} />}
      {label ?? status}
    </Box>
  );
}
